import { render, staticRenderFns } from "./SponsorRequests.vue?vue&type=template&id=430f0ff2"
import script from "./SponsorRequests.vue?vue&type=script&lang=js"
export * from "./SponsorRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports